import { render, staticRenderFns } from "./ScheduleForWeeks.vue?vue&type=template&id=355ecd3a"
import script from "./ScheduleForWeeks.vue?vue&type=script&lang=js"
export * from "./ScheduleForWeeks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports